import { render, staticRenderFns } from "./RequestPasswordResetForm.vue?vue&type=template&id=20d45dc0&scoped=true"
import script from "./RequestPasswordResetForm.vue?vue&type=script&lang=ts"
export * from "./RequestPasswordResetForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d45dc0",
  null
  
)

export default component.exports